import React from "react";
import Navbar from "./Navbar";
import Services from "./Services";
import Contact from "./Contact";
function ServicesPage()
{
    return(
        <>
        <Navbar/>
        <Services/>
        <Contact/>
        </>
    )
}
export default ServicesPage;